module.exports = __webpack_public_path__ + "static/media/img-emandamento-sanpaolo-jun23-2.81b3c06a.jpg";